export default __webpack_public_path__ + "static/media/p1.53d1564a.jpg";